import http from '../api/http'

export default class featureTogglesApi {
  static getFeatureToggles(applicationId) {
    return http.get(`api/SystemFeature/Application/${applicationId}`)
  }
}
